module.exports = __webpack_public_path__ + "static/img/lesson-demo.2365fbcc.png";